/**
 * Hero Block JavaScript
 */

(function () {
    'use strict';

    function prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function playWhenIdle(video) {
        const play = () => {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
                playPromise.catch(() => {});
            }
        };

        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(play, { timeout: 2000 });
            return;
        }

        if (document.readyState === 'complete') {
            play();
            return;
        }

        window.addEventListener('load', play, { once: true });
    }

    function isDesktop() {
        return window.matchMedia('(min-width: 992px)').matches;
    }

    function initHero(container) {
        const root = container || document;
        const videos = root.querySelectorAll('.hero__video');

        videos.forEach((video) => {
            const desktopOnly = video.closest('.hero--has-mobile-poster');

            const maybePlay = () => {
                if (prefersReducedMotion()) {
                    video.pause();
                    video.removeAttribute('autoplay');
                    return;
                }

                if (desktopOnly && !isDesktop()) {
                    video.pause();
                    return;
                }

                playWhenIdle(video);
            };

            maybePlay();

            if (desktopOnly && typeof window.matchMedia === 'function') {
                const mq = window.matchMedia('(min-width: 992px)');
                if (typeof mq.addEventListener === 'function') {
                    mq.addEventListener('change', maybePlay);
                }
            }
        });
    }

    function onPageReady(e) {
        const container = e?.detail?.container || document;
        if (container.querySelector('.hero')) {
            initHero(container);
        }
    }

    if (document.body?.hasAttribute?.('data-barba')) {
        document.addEventListener('barba:pageReady', onPageReady);
    } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => onPageReady({ detail: { container: document } }));
    } else {
        onPageReady({ detail: { container: document } });
    }
})();
